import { Components, Theme } from '@mui/material/styles'

export const switchTheme: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    color: 'secondary',
  },
}
